export default "__VITE_PUBLIC_ASSET__4a787981__"